/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type APIResponseBase,
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
} from '../models/APIResponseBase';
import {
    type OAuthTokenRevokeReq,
    OAuthTokenRevokeReqFromJSON,
    OAuthTokenRevokeReqToJSON,
} from '../models/OAuthTokenRevokeReq';

export interface PostSsoOidcTokensRevokeRequest {
    oAuthTokenRevokeReq: OAuthTokenRevokeReq;
    slashIDSdkVersion?: string;
}

/**
 * 
 */
export class SSOApi extends runtime.BaseAPI {

    /**
     * Creates request options for postSsoOidcTokensRevoke without sending the request
     * @deprecated
     */
    async postSsoOidcTokensRevokeRequestOpts(requestParameters: PostSsoOidcTokensRevokeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['oAuthTokenRevokeReq'] == null) {
            throw new runtime.RequiredError(
                'oAuthTokenRevokeReq',
                'Required parameter "oAuthTokenRevokeReq" was null or undefined when calling postSsoOidcTokensRevoke().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['slashIDSdkVersion'] != null) {
            headerParameters['SlashID-SdkVersion'] = String(requestParameters['slashIDSdkVersion']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/sso/oidc/tokens/revoke`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OAuthTokenRevokeReqToJSON(requestParameters['oAuthTokenRevokeReq']),
        };
    }

    /**
     * Revoke a previously obtained OAuth access or refresh token for an IdP. This endpoint is deprecated. Please use /sso/oidc/tokens/revoke/v2 instead. 
     * (Deprecated) Revoke an OAuth token obtained through SSO with OIDC
     * @deprecated
     */
    async postSsoOidcTokensRevokeRaw(requestParameters: PostSsoOidcTokensRevokeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.postSsoOidcTokensRevokeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Revoke a previously obtained OAuth access or refresh token for an IdP. This endpoint is deprecated. Please use /sso/oidc/tokens/revoke/v2 instead. 
     * (Deprecated) Revoke an OAuth token obtained through SSO with OIDC
     * @deprecated
     */
    async postSsoOidcTokensRevoke(requestParameters: PostSsoOidcTokensRevokeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postSsoOidcTokensRevokeRaw(requestParameters, initOverrides);
    }

}
